import React from "react";

import { Box, Card, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { get } from "lodash";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    boxShadow: "inset 0px -1px 0px #EEEEEE",
    padding: "1rem",
    minHeight: "72px",
  },
  heading: {
    justifyContent: "space-between",
  },

  lesson: {
    justifyContent: "space-between",
  },
  lessonDate: {
    display: "flex",
    flexDirection: "column",
    marginRight: "2rem",
    minWidth: "25%",

    [theme.breakpoints.down("xs")]: {
      marginRight: "0.5rem",
    },
  },
  lessonLearner: {
    display: "flex",
    flexDirection: "column",
    flex: 1,

    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      minWidth: "50%",
    },

    "& strong": {
      [theme.breakpoints.up("sm")]: {
        width: "50%",
      },
    },
  },
}));

const CardSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <Card>
      <Box
        flexGrow={1}
        className={clsx(get(classes, "container"), get(classes, "heading"))}
      >
        <Skeleton variant="text" width={80} height={32} />
        <Skeleton variant="text" width={75} height={32} />
      </Box>

      <Box
        flexGrow={1}
        className={clsx(get(classes, "container"), get(classes, "lesson"))}
      >
        <div className={get(classes, "lessonDate")}>
          <Skeleton variant="text" width={80} height={32} />
          <Skeleton variant="text" width={80} height={32} />
        </div>
        <div className={get(classes, "lessonLearner")}>
          <Skeleton variant="text" width="100%" height={32} />
          <Skeleton variant="text" width="100%" height={32} />
        </div>
      </Box>
    </Card>
  );
};

export default CardSkeleton;
